import React from 'react';

import { faClass } from '@/constants/icons';

import styles from './IconBadge.module.scss';

/**
 * Icona dentro un quadratino colorato (tinta container) — per intestazioni di
 * card/sezioni, KPI, header. Più leggibile e "diretta" di una semplice <i>.
 *
 * Props:
 * - icon:  classe FontAwesome (`ICONS.x` / "fa-solid fa-id-card") o glifo nudo
 *          ("fa-id-card") — `faClass` aggiunge il prefisso `fa-solid` se assente.
 * - tint:  primary (default) | teal | success | warning | danger | info | purple | neutral
 * - size:  sm | md (default) | lg
 */
export default function IconBadge({ icon, tint = 'primary', size = 'md', className = '' }) {
  return (
    <span
      className={`${styles.badge} ${styles[tint] || styles.primary} ${styles[size] || styles.md} ${className}`.trim()}
      aria-hidden="true"
    >
      <i className={faClass(icon)} />
    </span>
  );
}
